import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'
import type SessionService from 'teacher-ui-client/services/session'

export default class FastPhonicsReportingProgressReviewIndexRoute extends Route {
  @service session!: SessionService

  @service router!: RouterService

  beforeModel() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const isSubco = this.session.currentTeacher.subcoFor(subscriptionType)

    const routePrefix = 'reporting.ui-scope.fast-phonics.progress.review'
    const redirectRoute = isSubco ? `${routePrefix}.teachers` : `${routePrefix}.students`

    void this.router.replaceWith(redirectRoute)
  }
}
